module.exports = __webpack_public_path__ + "static/media/header1.93895aae.png";